import StatsItem from "@entities/thirdPartyDiscovery/ui/Audience/StatsItem";
import { AudienceUserInsights } from "@shared/lib/types/socialMediaInfluencerV2";
import { Card, Col, Flex, Row, Typography } from "antd";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import styles from "./styles.module.scss";

const { Title, Text } = Typography;

interface Props {
  audienceInsights?: AudienceUserInsights;
  platform: string;
}

export function AudienceInsights({ audienceInsights, platform }: Props) {
  const audienceGender = audienceInsights?.audienceGender || [];

  const genderLabels: string[] =
    audienceGender?.map((g) => (g.value === "MALE" ? "Male" : "Female")) || [];

  const genderData =
    audienceGender?.map((g) => Number(g.percentage.toFixed(2))) || [];

  const genderColors = ["#FF6384", "#36A2EB"];

  return (
    <Card className={styles.card} bodyStyle={{ padding: 20 }}>
      <Flex vertical gap={16}>
        <Title level={4} style={{ margin: 0 }}>
          Audience Insights
        </Title>
        <Row gutter={[20, 20]}>
          <Col xs={24} md={7}>
            <Card style={{ height: "300px", borderRadius: "10px" }}>
              <Title level={5} style={{ marginBlock: 0, marginBottom: 10 }}>
                Age Range
              </Title>
              <StatsItem
                items={
                  audienceInsights?.audienceAge.map((item) => ({
                    name: item.range,
                    value: item.percentage,
                  })) || []
                }
                isNew={true}
              />
            </Card>
          </Col>
          <Col md={7}>
            <Card style={{ borderRadius: "10px", width: "100%" }}>
              <Title level={5} style={{ marginBlock: 0, marginBottom: 10 }}>
                {platform === "instagram" ? "City" : "Country"} wise split
              </Title>

              <StatsItem
                items={
                  audienceInsights?.[
                    platform === "instagram"
                      ? "audienceTopCity"
                      : "audienceTopCountry"
                  ].map((item) => ({
                    name: item.name,
                    value: item.percentage,
                  })) || []
                }
                isNew={true}
              />
            </Card>
          </Col>
          <Col md={7}>
            {audienceGender && audienceGender.length > 0 && (
              <Card
                style={{
                  width: "100%",
                  borderRadius: 10,
                  height: "312px",
                }}
              >
                <Title level={5} style={{ marginBlock: 0, marginBottom: 10 }}>
                  Male Female Ratio
                </Title>
                <div style={{ width: "250px", height: "250px" }}>
                  <Doughnut
                    data={{
                      labels: genderLabels,
                      datasets: [
                        {
                          data: genderData,
                          backgroundColor: genderColors,
                          borderWidth: 2,
                          hoverOffset: 8,
                          borderRadius: 10,
                        },
                      ],
                    }}
                    options={{
                      cutout: "50%",
                      maintainAspectRatio: true,
                      plugins: {
                        legend: {
                          align: "end",
                          position: "top",
                          fullSize: true,
                          // display: false,
                        },

                        datalabels: {
                          color: "#222",
                          font: { size: 12 },
                          formatter: (value: number) => Math.round(value),
                          display: true,
                        },
                        tooltip: {
                          enabled: false,
                        },
                      },
                    }}
                    plugins={[ChartDataLabels]}
                  />
                </div>
              </Card>
            )}
          </Col>
        </Row>
      </Flex>
    </Card>
  );
}
